/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_SubtitleInputs */

const en_landing_cta_subtitle = /** @type {(inputs: Landing_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Equities and FICC desks using Inginuiti to grow commission revenue and capture market share.`)
};

/**
* | output |
* | --- |
* | "Join the Equities and FICC desks using Inginuiti to grow commission revenue and capture market share." |
*
* @param {Landing_Cta_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_cta_subtitle = /** @type {((inputs?: Landing_Cta_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_cta_subtitle(inputs)
});